export const COUNTRY_CODES: { value: string; flag: string }[] = [
  { value: "+852", flag: "🇭🇰" },
  { value: "+853", flag: "🇲🇴" },
  { value: "+886", flag: "🇹🇼" },
  { value: "+44", flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿" },
];